{
  "version": 1,
  "asset_id": "59f07aca-3a1c-4df1-8bfd-8fd119fa0a4d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/59f07aca-3a1c-4df1-8bfd-8fd119fa0a4d/hiatal-type-1-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/59f07aca-3a1c-4df1-8bfd-8fd119fa0a4d/hiatal-type-1-v3-800.jpg",
  "original_filename": "hiatal-type-1-v3-800.jpg",
  "size": 112820,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:09:19Z"
}
